/* eslint-disable no-redeclare */
import { z } from 'zod';

export const ImmediateCoverageDto = z.enum([
  'immediately',
  '2_weeks',
  'not_sure',
]);

export type ImmediateCoverageDto = z.infer<typeof ImmediateCoverageDto>;
